/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import { types, applySnapshot, getSnapshot } from 'mobx-state-tree';
import { toJS } from 'mobx';
import Framework from '@greenville/framework';
import * as constants from '../../constants/ServiceConstants';

const ShareGraphModel = types
  .model('ShareGraphModel', {
    sharedWith: types.optional(types.array(types.string), []),
    notFound: types.optional(types.array(types.string), []),
    error: types.maybeNull(types.string)
  })
  .views((self) => ({
    get shareResult() {
      return {
        sharedWith: toJS(self.sharedWith),
        notFound: toJS(self.notFound),
        error: self.error
      };
    }
  }))
  .actions((self) => ({
    shareGraph(payload) {
      applySnapshot(self, {
        ...getSnapshot(self),
        error: null
      });
      Framework.getEventManager().publish(constants.SHARE_GRAPH, { payload });
    },
    setResponse(response) {
      applySnapshot(self, {
        ...getSnapshot(self),
        sharedWith: response?.sharedWith || [],
        notFound: response?.notFound || []
      });
      Framework.getEventManager().publish(constants.SHARE_GRAPH_SUCCESS, response);
    },
    setError(errorMessage) {
      applySnapshot(self, {
        ...getSnapshot(self),
        error: errorMessage
      });
      Framework.getEventManager().publish(constants.SHARE_GRAPH_ERROR, { error: errorMessage });
    },
    resetState() {
      applySnapshot(self, {
        sharedWith: [],
        notFound: [],
        error: null
      });
    }
  }));

export default ShareGraphModel;
